import React from 'react';
import styles from './Contact.module.css';

function Contact() {
  return (
    <section className={styles.contact}>
      <h2>Contact Us</h2>
      <div><strong>Phone:</strong> +211922590325, +211926135385, +211922558399</div>
      <div><strong>Location:</strong> Mauna near Suk Ardep, Juba South Sudan</div>
      <div><strong>Email:</strong> info.juba@destinyschool.site

</div>
      <div className={styles.socialLinks}>
        <span>Connect with us:</span>
        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a>
        <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer">TikTok</a>
        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">Instagram</a>
      </div>
    </section>
  );
}

export default Contact;
